function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 48
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30 50h40M50 30l20 20-20 20"
});

var SvgCircleArrow = function SvgCircleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "arrow-circle",
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2);
};

export default SvgCircleArrow;